import React from 'react';
import MaterialPaper from '@material-ui/core/Paper';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3, 3),
      margin: '6px 0'
    },
    warn: {
      backgroundColor: '#676767'
    },
    noPadding: {
      padding: 0
    }
  })
);

const Paper = ({
  children,
  warn,
  noPadding,
  className,
  ...props
}: {
  children: any;
  noPadding?: boolean;
  warn?: boolean;
  className?: string;
}) => {
  const classes = useStyles();
  return (
    <MaterialPaper
      square={true}
      {...props}
      elevation={0}
      className={classNames(
        classes.root,
        warn && classes.warn,
        noPadding && classes.noPadding,
        className
      )}
    >
      {children}
    </MaterialPaper>
  );
};

export default Paper;
